/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddSimulationPositionRequestDto } from '../models';
// @ts-ignore
import type { CreateHierarchySimulationRequestDto } from '../models';
// @ts-ignore
import type { DeleteSimulationResponseDto } from '../models';
// @ts-ignore
import type { DictionaryItemDto } from '../models';
// @ts-ignore
import type { HierarchySimulationDto } from '../models';
// @ts-ignore
import type { HierarchySimulationsPageResponseDto } from '../models';
// @ts-ignore
import type { SimulationAccessDto } from '../models';
// @ts-ignore
import type { SimulationStatusDto } from '../models';
// @ts-ignore
import type { UpdateSimulationAccessRequestDto } from '../models';
// @ts-ignore
import type { UpdateSimulationDetailsRequestDto } from '../models';
// @ts-ignore
import type { UpdateSimulationStatusRequestDto } from '../models';
/**
 * HierarchySimulationRestApi - axios parameter creator
 * @export
 */
export const HierarchySimulationRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds a new position (dictionary item) to a simulation. The position will be available for assignment to vacancy nodes. 
         * @summary Add Position to Simulation
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {AddSimulationPositionRequestDto} addSimulationPositionRequestDto Add position to simulation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSimulationPosition: async (simulationId: string, addSimulationPositionRequestDto: AddSimulationPositionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('addSimulationPosition', 'simulationId', simulationId)
            // verify required parameter 'addSimulationPositionRequestDto' is not null or undefined
            assertParamExists('addSimulationPosition', 'addSimulationPositionRequestDto', addSimulationPositionRequestDto)
            const localVarPath = `/api/v2/hierarchy-units/simulations/{simulationId}/positions/add`
                .replace(`{${"simulationId"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSimulationPositionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new hierarchy simulation based on current hierarchy structure
         * @summary Create Hierarchy Simulation
         * @param {CreateHierarchySimulationRequestDto} createHierarchySimulationRequestDto Create hierarchy simulation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHierarchySimulation: async (createHierarchySimulationRequestDto: CreateHierarchySimulationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createHierarchySimulationRequestDto' is not null or undefined
            assertParamExists('createHierarchySimulation', 'createHierarchySimulationRequestDto', createHierarchySimulationRequestDto)
            const localVarPath = `/api/v2/hierarchy-units/simulations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createHierarchySimulationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently deletes a hierarchy simulation and all its associated data.  This is a hard delete operation that: - Removes the simulation record completely - Deletes all hierarchy units within the simulation - Cannot be undone  Warning: This operation is irreversible. Consider using status update to DELETED for soft delete instead. 
         * @summary Delete Hierarchy Simulation
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHierarchySimulation: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('deleteHierarchySimulation', 'simulationId', simulationId)
            const localVarPath = `/api/v2/hierarchy-units/simulations/{simulationId}`
                .replace(`{${"simulationId"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a position from the simulation.  Warning: This operation may affect vacancy nodes that reference this position. 
         * @summary Delete Position from Simulation
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {string} positionId Position ID (position code from dictionary)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSimulationPosition: async (simulationId: string, positionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('deleteSimulationPosition', 'simulationId', simulationId)
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('deleteSimulationPosition', 'positionId', positionId)
            const localVarPath = `/api/v2/hierarchy-units/simulations/{simulationId}/positions/{positionId}`
                .replace(`{${"simulationId"}}`, encodeURIComponent(String(simulationId)))
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve hierarchy simulations with pagination support
         * @summary Get Hierarchy Simulations with Pagination
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SimulationStatusDto} [simulationStatus] Filter simulations by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHierarchySimulations: async (pageSize: number, page: number, simulationStatus?: SimulationStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getHierarchySimulations', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getHierarchySimulations', 'page', page)
            const localVarPath = `/api/v2/hierarchy-units/simulations-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (simulationStatus !== undefined) {
                localVarQueryParameter['simulationStatus'] = simulationStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves access information for a simulation: - Eligible users: All users with STRUCTURE_MANAGEMENT permission who can manage the simulation - Users with access: Users who currently have explicit access to this simulation (excluding the owner) 
         * @summary Get Simulation Access Information
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationAccess: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getSimulationAccess', 'simulationId', simulationId)
            const localVarPath = `/api/v2/hierarchy-units/simulations/{simulationId}/access`
                .replace(`{${"simulationId"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all positions (dictionary items) defined for a specific simulation. These positions can be assigned to vacancy nodes in the simulation. 
         * @summary Get Simulation Positions
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationPositions: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getSimulationPositions', 'simulationId', simulationId)
            const localVarPath = `/api/v2/hierarchy-units/simulations/{simulationId}/positions`
                .replace(`{${"simulationId"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the name and/or description of a hierarchy simulation.  This operation allows updating: - Name: The display name of the simulation (required if provided) - Description: The detailed description of the simulation (optional)  At least one field (name or description) must be provided in the request. 
         * @summary Update Hierarchy Simulation Details
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {UpdateSimulationDetailsRequestDto | null} updateSimulationDetailsRequestDto Update simulation details request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHierarchySimulationDetails: async (simulationId: string, updateSimulationDetailsRequestDto: UpdateSimulationDetailsRequestDto | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateHierarchySimulationDetails', 'simulationId', simulationId)
            // verify required parameter 'updateSimulationDetailsRequestDto' is not null or undefined
            assertParamExists('updateHierarchySimulationDetails', 'updateSimulationDetailsRequestDto', updateSimulationDetailsRequestDto)
            const localVarPath = `/api/v2/hierarchy-units/simulations/{simulationId}`
                .replace(`{${"simulationId"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSimulationDetailsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the status of a hierarchy simulation.  Available status transitions: - ACTIVE → ARCHIVED: Archives the simulation - ACTIVE → DELETED: Soft deletes the simulation - ARCHIVED → ACTIVE: Reactivates archived simulation - ARCHIVED → DELETED: Soft deletes archived simulation  Note: DELETED status is a soft delete - simulation data is preserved but hidden from normal queries. 
         * @summary Update Hierarchy Simulation Status
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {UpdateSimulationStatusRequestDto} updateSimulationStatusRequestDto Update simulation status request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHierarchySimulationStatus: async (simulationId: string, updateSimulationStatusRequestDto: UpdateSimulationStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateHierarchySimulationStatus', 'simulationId', simulationId)
            // verify required parameter 'updateSimulationStatusRequestDto' is not null or undefined
            assertParamExists('updateHierarchySimulationStatus', 'updateSimulationStatusRequestDto', updateSimulationStatusRequestDto)
            const localVarPath = `/api/v2/hierarchy-units/simulations/{simulationId}/status`
                .replace(`{${"simulationId"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSimulationStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the list of users who have access to manage the simulation. This replaces the existing access list with the provided user IDs.  Note: The simulation owner always has access and doesn\'t need to be included. 
         * @summary Update Simulation Access
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {UpdateSimulationAccessRequestDto} updateSimulationAccessRequestDto Update simulation access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSimulationAccess: async (simulationId: string, updateSimulationAccessRequestDto: UpdateSimulationAccessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateSimulationAccess', 'simulationId', simulationId)
            // verify required parameter 'updateSimulationAccessRequestDto' is not null or undefined
            assertParamExists('updateSimulationAccess', 'updateSimulationAccessRequestDto', updateSimulationAccessRequestDto)
            const localVarPath = `/api/v2/hierarchy-units/simulations/{simulationId}/access/update`
                .replace(`{${"simulationId"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSimulationAccessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HierarchySimulationRestApi - functional programming interface
 * @export
 */
export const HierarchySimulationRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HierarchySimulationRestApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds a new position (dictionary item) to a simulation. The position will be available for assignment to vacancy nodes. 
         * @summary Add Position to Simulation
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {AddSimulationPositionRequestDto} addSimulationPositionRequestDto Add position to simulation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSimulationPosition(simulationId: string, addSimulationPositionRequestDto: AddSimulationPositionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionaryItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSimulationPosition(simulationId, addSimulationPositionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchySimulationRestApi.addSimulationPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new hierarchy simulation based on current hierarchy structure
         * @summary Create Hierarchy Simulation
         * @param {CreateHierarchySimulationRequestDto} createHierarchySimulationRequestDto Create hierarchy simulation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHierarchySimulation(createHierarchySimulationRequestDto: CreateHierarchySimulationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HierarchySimulationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHierarchySimulation(createHierarchySimulationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchySimulationRestApi.createHierarchySimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Permanently deletes a hierarchy simulation and all its associated data.  This is a hard delete operation that: - Removes the simulation record completely - Deletes all hierarchy units within the simulation - Cannot be undone  Warning: This operation is irreversible. Consider using status update to DELETED for soft delete instead. 
         * @summary Delete Hierarchy Simulation
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHierarchySimulation(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteSimulationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHierarchySimulation(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchySimulationRestApi.deleteHierarchySimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes a position from the simulation.  Warning: This operation may affect vacancy nodes that reference this position. 
         * @summary Delete Position from Simulation
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {string} positionId Position ID (position code from dictionary)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSimulationPosition(simulationId: string, positionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSimulationPosition(simulationId, positionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchySimulationRestApi.deleteSimulationPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve hierarchy simulations with pagination support
         * @summary Get Hierarchy Simulations with Pagination
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SimulationStatusDto} [simulationStatus] Filter simulations by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHierarchySimulations(pageSize: number, page: number, simulationStatus?: SimulationStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HierarchySimulationsPageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHierarchySimulations(pageSize, page, simulationStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchySimulationRestApi.getHierarchySimulations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves access information for a simulation: - Eligible users: All users with STRUCTURE_MANAGEMENT permission who can manage the simulation - Users with access: Users who currently have explicit access to this simulation (excluding the owner) 
         * @summary Get Simulation Access Information
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulationAccess(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulationAccessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulationAccess(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchySimulationRestApi.getSimulationAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all positions (dictionary items) defined for a specific simulation. These positions can be assigned to vacancy nodes in the simulation. 
         * @summary Get Simulation Positions
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulationPositions(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DictionaryItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulationPositions(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchySimulationRestApi.getSimulationPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the name and/or description of a hierarchy simulation.  This operation allows updating: - Name: The display name of the simulation (required if provided) - Description: The detailed description of the simulation (optional)  At least one field (name or description) must be provided in the request. 
         * @summary Update Hierarchy Simulation Details
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {UpdateSimulationDetailsRequestDto | null} updateSimulationDetailsRequestDto Update simulation details request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHierarchySimulationDetails(simulationId: string, updateSimulationDetailsRequestDto: UpdateSimulationDetailsRequestDto | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HierarchySimulationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHierarchySimulationDetails(simulationId, updateSimulationDetailsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchySimulationRestApi.updateHierarchySimulationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the status of a hierarchy simulation.  Available status transitions: - ACTIVE → ARCHIVED: Archives the simulation - ACTIVE → DELETED: Soft deletes the simulation - ARCHIVED → ACTIVE: Reactivates archived simulation - ARCHIVED → DELETED: Soft deletes archived simulation  Note: DELETED status is a soft delete - simulation data is preserved but hidden from normal queries. 
         * @summary Update Hierarchy Simulation Status
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {UpdateSimulationStatusRequestDto} updateSimulationStatusRequestDto Update simulation status request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHierarchySimulationStatus(simulationId: string, updateSimulationStatusRequestDto: UpdateSimulationStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHierarchySimulationStatus(simulationId, updateSimulationStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchySimulationRestApi.updateHierarchySimulationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the list of users who have access to manage the simulation. This replaces the existing access list with the provided user IDs.  Note: The simulation owner always has access and doesn\'t need to be included. 
         * @summary Update Simulation Access
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {UpdateSimulationAccessRequestDto} updateSimulationAccessRequestDto Update simulation access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSimulationAccess(simulationId: string, updateSimulationAccessRequestDto: UpdateSimulationAccessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSimulationAccess(simulationId, updateSimulationAccessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchySimulationRestApi.updateSimulationAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HierarchySimulationRestApi - factory interface
 * @export
 */
export const HierarchySimulationRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HierarchySimulationRestApiFp(configuration)
    return {
        /**
         * Adds a new position (dictionary item) to a simulation. The position will be available for assignment to vacancy nodes. 
         * @summary Add Position to Simulation
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {AddSimulationPositionRequestDto} addSimulationPositionRequestDto Add position to simulation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSimulationPosition(simulationId: string, addSimulationPositionRequestDto: AddSimulationPositionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryItemDto> {
            return localVarFp.addSimulationPosition(simulationId, addSimulationPositionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new hierarchy simulation based on current hierarchy structure
         * @summary Create Hierarchy Simulation
         * @param {CreateHierarchySimulationRequestDto} createHierarchySimulationRequestDto Create hierarchy simulation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHierarchySimulation(createHierarchySimulationRequestDto: CreateHierarchySimulationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<HierarchySimulationDto> {
            return localVarFp.createHierarchySimulation(createHierarchySimulationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Permanently deletes a hierarchy simulation and all its associated data.  This is a hard delete operation that: - Removes the simulation record completely - Deletes all hierarchy units within the simulation - Cannot be undone  Warning: This operation is irreversible. Consider using status update to DELETED for soft delete instead. 
         * @summary Delete Hierarchy Simulation
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHierarchySimulation(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteSimulationResponseDto> {
            return localVarFp.deleteHierarchySimulation(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a position from the simulation.  Warning: This operation may affect vacancy nodes that reference this position. 
         * @summary Delete Position from Simulation
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {string} positionId Position ID (position code from dictionary)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSimulationPosition(simulationId: string, positionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSimulationPosition(simulationId, positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve hierarchy simulations with pagination support
         * @summary Get Hierarchy Simulations with Pagination
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SimulationStatusDto} [simulationStatus] Filter simulations by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHierarchySimulations(pageSize: number, page: number, simulationStatus?: SimulationStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<HierarchySimulationsPageResponseDto> {
            return localVarFp.getHierarchySimulations(pageSize, page, simulationStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves access information for a simulation: - Eligible users: All users with STRUCTURE_MANAGEMENT permission who can manage the simulation - Users with access: Users who currently have explicit access to this simulation (excluding the owner) 
         * @summary Get Simulation Access Information
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationAccess(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<SimulationAccessDto> {
            return localVarFp.getSimulationAccess(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all positions (dictionary items) defined for a specific simulation. These positions can be assigned to vacancy nodes in the simulation. 
         * @summary Get Simulation Positions
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationPositions(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryItemDto>> {
            return localVarFp.getSimulationPositions(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the name and/or description of a hierarchy simulation.  This operation allows updating: - Name: The display name of the simulation (required if provided) - Description: The detailed description of the simulation (optional)  At least one field (name or description) must be provided in the request. 
         * @summary Update Hierarchy Simulation Details
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {UpdateSimulationDetailsRequestDto | null} updateSimulationDetailsRequestDto Update simulation details request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHierarchySimulationDetails(simulationId: string, updateSimulationDetailsRequestDto: UpdateSimulationDetailsRequestDto | null, options?: RawAxiosRequestConfig): AxiosPromise<HierarchySimulationDto> {
            return localVarFp.updateHierarchySimulationDetails(simulationId, updateSimulationDetailsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the status of a hierarchy simulation.  Available status transitions: - ACTIVE → ARCHIVED: Archives the simulation - ACTIVE → DELETED: Soft deletes the simulation - ARCHIVED → ACTIVE: Reactivates archived simulation - ARCHIVED → DELETED: Soft deletes archived simulation  Note: DELETED status is a soft delete - simulation data is preserved but hidden from normal queries. 
         * @summary Update Hierarchy Simulation Status
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {UpdateSimulationStatusRequestDto} updateSimulationStatusRequestDto Update simulation status request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHierarchySimulationStatus(simulationId: string, updateSimulationStatusRequestDto: UpdateSimulationStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateHierarchySimulationStatus(simulationId, updateSimulationStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the list of users who have access to manage the simulation. This replaces the existing access list with the provided user IDs.  Note: The simulation owner always has access and doesn\'t need to be included. 
         * @summary Update Simulation Access
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {UpdateSimulationAccessRequestDto} updateSimulationAccessRequestDto Update simulation access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSimulationAccess(simulationId: string, updateSimulationAccessRequestDto: UpdateSimulationAccessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSimulationAccess(simulationId, updateSimulationAccessRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HierarchySimulationRestApi - interface
 * @export
 * @interface HierarchySimulationRestApi
 */
export interface HierarchySimulationRestApiInterface {
    /**
     * Adds a new position (dictionary item) to a simulation. The position will be available for assignment to vacancy nodes. 
     * @summary Add Position to Simulation
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {AddSimulationPositionRequestDto} addSimulationPositionRequestDto Add position to simulation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApiInterface
     */
    addSimulationPosition(simulationId: string, addSimulationPositionRequestDto: AddSimulationPositionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryItemDto>;

    /**
     * Create a new hierarchy simulation based on current hierarchy structure
     * @summary Create Hierarchy Simulation
     * @param {CreateHierarchySimulationRequestDto} createHierarchySimulationRequestDto Create hierarchy simulation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApiInterface
     */
    createHierarchySimulation(createHierarchySimulationRequestDto: CreateHierarchySimulationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<HierarchySimulationDto>;

    /**
     * Permanently deletes a hierarchy simulation and all its associated data.  This is a hard delete operation that: - Removes the simulation record completely - Deletes all hierarchy units within the simulation - Cannot be undone  Warning: This operation is irreversible. Consider using status update to DELETED for soft delete instead. 
     * @summary Delete Hierarchy Simulation
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApiInterface
     */
    deleteHierarchySimulation(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteSimulationResponseDto>;

    /**
     * Removes a position from the simulation.  Warning: This operation may affect vacancy nodes that reference this position. 
     * @summary Delete Position from Simulation
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {string} positionId Position ID (position code from dictionary)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApiInterface
     */
    deleteSimulationPosition(simulationId: string, positionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Retrieve hierarchy simulations with pagination support
     * @summary Get Hierarchy Simulations with Pagination
     * @param {number} pageSize 
     * @param {number} page 
     * @param {SimulationStatusDto} [simulationStatus] Filter simulations by status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApiInterface
     */
    getHierarchySimulations(pageSize: number, page: number, simulationStatus?: SimulationStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<HierarchySimulationsPageResponseDto>;

    /**
     * Retrieves access information for a simulation: - Eligible users: All users with STRUCTURE_MANAGEMENT permission who can manage the simulation - Users with access: Users who currently have explicit access to this simulation (excluding the owner) 
     * @summary Get Simulation Access Information
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApiInterface
     */
    getSimulationAccess(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<SimulationAccessDto>;

    /**
     * Retrieves all positions (dictionary items) defined for a specific simulation. These positions can be assigned to vacancy nodes in the simulation. 
     * @summary Get Simulation Positions
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApiInterface
     */
    getSimulationPositions(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryItemDto>>;

    /**
     * Updates the name and/or description of a hierarchy simulation.  This operation allows updating: - Name: The display name of the simulation (required if provided) - Description: The detailed description of the simulation (optional)  At least one field (name or description) must be provided in the request. 
     * @summary Update Hierarchy Simulation Details
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {UpdateSimulationDetailsRequestDto | null} updateSimulationDetailsRequestDto Update simulation details request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApiInterface
     */
    updateHierarchySimulationDetails(simulationId: string, updateSimulationDetailsRequestDto: UpdateSimulationDetailsRequestDto | null, options?: RawAxiosRequestConfig): AxiosPromise<HierarchySimulationDto>;

    /**
     * Updates the status of a hierarchy simulation.  Available status transitions: - ACTIVE → ARCHIVED: Archives the simulation - ACTIVE → DELETED: Soft deletes the simulation - ARCHIVED → ACTIVE: Reactivates archived simulation - ARCHIVED → DELETED: Soft deletes archived simulation  Note: DELETED status is a soft delete - simulation data is preserved but hidden from normal queries. 
     * @summary Update Hierarchy Simulation Status
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {UpdateSimulationStatusRequestDto} updateSimulationStatusRequestDto Update simulation status request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApiInterface
     */
    updateHierarchySimulationStatus(simulationId: string, updateSimulationStatusRequestDto: UpdateSimulationStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Updates the list of users who have access to manage the simulation. This replaces the existing access list with the provided user IDs.  Note: The simulation owner always has access and doesn\'t need to be included. 
     * @summary Update Simulation Access
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {UpdateSimulationAccessRequestDto} updateSimulationAccessRequestDto Update simulation access request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApiInterface
     */
    updateSimulationAccess(simulationId: string, updateSimulationAccessRequestDto: UpdateSimulationAccessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * HierarchySimulationRestApi - object-oriented interface
 * @export
 * @class HierarchySimulationRestApi
 * @extends {BaseAPI}
 */
export class HierarchySimulationRestApi extends BaseAPI implements HierarchySimulationRestApiInterface {
    /**
     * Adds a new position (dictionary item) to a simulation. The position will be available for assignment to vacancy nodes. 
     * @summary Add Position to Simulation
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {AddSimulationPositionRequestDto} addSimulationPositionRequestDto Add position to simulation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApi
     */
    public addSimulationPosition(simulationId: string, addSimulationPositionRequestDto: AddSimulationPositionRequestDto, options?: RawAxiosRequestConfig) {
        return HierarchySimulationRestApiFp(this.configuration).addSimulationPosition(simulationId, addSimulationPositionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new hierarchy simulation based on current hierarchy structure
     * @summary Create Hierarchy Simulation
     * @param {CreateHierarchySimulationRequestDto} createHierarchySimulationRequestDto Create hierarchy simulation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApi
     */
    public createHierarchySimulation(createHierarchySimulationRequestDto: CreateHierarchySimulationRequestDto, options?: RawAxiosRequestConfig) {
        return HierarchySimulationRestApiFp(this.configuration).createHierarchySimulation(createHierarchySimulationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Permanently deletes a hierarchy simulation and all its associated data.  This is a hard delete operation that: - Removes the simulation record completely - Deletes all hierarchy units within the simulation - Cannot be undone  Warning: This operation is irreversible. Consider using status update to DELETED for soft delete instead. 
     * @summary Delete Hierarchy Simulation
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApi
     */
    public deleteHierarchySimulation(simulationId: string, options?: RawAxiosRequestConfig) {
        return HierarchySimulationRestApiFp(this.configuration).deleteHierarchySimulation(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes a position from the simulation.  Warning: This operation may affect vacancy nodes that reference this position. 
     * @summary Delete Position from Simulation
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {string} positionId Position ID (position code from dictionary)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApi
     */
    public deleteSimulationPosition(simulationId: string, positionId: string, options?: RawAxiosRequestConfig) {
        return HierarchySimulationRestApiFp(this.configuration).deleteSimulationPosition(simulationId, positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve hierarchy simulations with pagination support
     * @summary Get Hierarchy Simulations with Pagination
     * @param {number} pageSize 
     * @param {number} page 
     * @param {SimulationStatusDto} [simulationStatus] Filter simulations by status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApi
     */
    public getHierarchySimulations(pageSize: number, page: number, simulationStatus?: SimulationStatusDto, options?: RawAxiosRequestConfig) {
        return HierarchySimulationRestApiFp(this.configuration).getHierarchySimulations(pageSize, page, simulationStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves access information for a simulation: - Eligible users: All users with STRUCTURE_MANAGEMENT permission who can manage the simulation - Users with access: Users who currently have explicit access to this simulation (excluding the owner) 
     * @summary Get Simulation Access Information
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApi
     */
    public getSimulationAccess(simulationId: string, options?: RawAxiosRequestConfig) {
        return HierarchySimulationRestApiFp(this.configuration).getSimulationAccess(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all positions (dictionary items) defined for a specific simulation. These positions can be assigned to vacancy nodes in the simulation. 
     * @summary Get Simulation Positions
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApi
     */
    public getSimulationPositions(simulationId: string, options?: RawAxiosRequestConfig) {
        return HierarchySimulationRestApiFp(this.configuration).getSimulationPositions(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the name and/or description of a hierarchy simulation.  This operation allows updating: - Name: The display name of the simulation (required if provided) - Description: The detailed description of the simulation (optional)  At least one field (name or description) must be provided in the request. 
     * @summary Update Hierarchy Simulation Details
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {UpdateSimulationDetailsRequestDto | null} updateSimulationDetailsRequestDto Update simulation details request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApi
     */
    public updateHierarchySimulationDetails(simulationId: string, updateSimulationDetailsRequestDto: UpdateSimulationDetailsRequestDto | null, options?: RawAxiosRequestConfig) {
        return HierarchySimulationRestApiFp(this.configuration).updateHierarchySimulationDetails(simulationId, updateSimulationDetailsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the status of a hierarchy simulation.  Available status transitions: - ACTIVE → ARCHIVED: Archives the simulation - ACTIVE → DELETED: Soft deletes the simulation - ARCHIVED → ACTIVE: Reactivates archived simulation - ARCHIVED → DELETED: Soft deletes archived simulation  Note: DELETED status is a soft delete - simulation data is preserved but hidden from normal queries. 
     * @summary Update Hierarchy Simulation Status
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {UpdateSimulationStatusRequestDto} updateSimulationStatusRequestDto Update simulation status request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApi
     */
    public updateHierarchySimulationStatus(simulationId: string, updateSimulationStatusRequestDto: UpdateSimulationStatusRequestDto, options?: RawAxiosRequestConfig) {
        return HierarchySimulationRestApiFp(this.configuration).updateHierarchySimulationStatus(simulationId, updateSimulationStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the list of users who have access to manage the simulation. This replaces the existing access list with the provided user IDs.  Note: The simulation owner always has access and doesn\'t need to be included. 
     * @summary Update Simulation Access
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {UpdateSimulationAccessRequestDto} updateSimulationAccessRequestDto Update simulation access request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchySimulationRestApi
     */
    public updateSimulationAccess(simulationId: string, updateSimulationAccessRequestDto: UpdateSimulationAccessRequestDto, options?: RawAxiosRequestConfig) {
        return HierarchySimulationRestApiFp(this.configuration).updateSimulationAccess(simulationId, updateSimulationAccessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

